type HedvigSymbolProps = {
  color?: string
  size?: string
}

export const HedvigSymbol = ({ color = 'currentColor', size = '1.5rem' }: HedvigSymbolProps) => (
  <svg width={size} height={size} fill="none" color={color} viewBox="0 0 40 40" aria-label="Hedvig logo">
    <path
      d="M20 0C8.95385 0 0 8.95385 0 20C0 31.0462 8.95385 40 20 40C31.0462 40 40 31.0462 40 20C40 8.95384 31.0462 0 20 0ZM20 37.1692C10.5385 37.1692 2.83077 29.4615 2.83077 20C2.83077 10.5385 10.5385 2.83077 20 2.83077C29.4615 2.83077 37.1692 10.5385 37.1692 20C37.1692 29.4615 29.4615 37.1692 20 37.1692Z"
      fill="currentColor"
    />
    <path d="M25 18.5078H15V10.0001H12V30.0001H15V21.5078H25V30.0001H28V10.0001H25V18.5078Z" fill="currentColor" />
  </svg>
)
